import { useEffect, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
}

const channels = [
  { key: "wechat", label: "微信", icon: "ri-wechat-line" },
  { key: "weibo", label: "微博", icon: "ri-weibo-line" },
  { key: "qq", label: "QQ", icon: "ri-qq-line" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function ShareDialog({ open, onClose, title }: Props) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!open) return;
    setMessage("");
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleChannel = async (key: string, label: string) => {
    if (key === "link") {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setMessage("链接已复制到剪贴板，可以粘贴给朋友了");
      } catch {
        setMessage("复制失败，请手动复制浏览器地址栏链接");
      }
      return;
    }
    setMessage(`已唤起「${label}」分享面板（演示效果，不会实际发送）`);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center px-0 sm:px-4">
      <button
        type="button"
        aria-label="关闭分享弹窗"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/50 animate-fadeIn cursor-pointer"
      />
      <div className="relative w-full sm:max-w-md bg-background-50 rounded-t-xl sm:rounded-lg p-5 md:p-6 animate-fadeUp">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">分享这篇资讯</h3>
            <p className="mt-1 text-xs text-foreground-600 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 cursor-pointer"
            aria-label="关闭"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={() => handleChannel(channel.key, channel.label)}
              className="flex flex-col items-center gap-2 py-3 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 rounded-full bg-background-50 flex items-center justify-center text-primary-600">
                <i className={`${channel.icon} text-xl`} />
              </span>
              <span className="text-xs text-foreground-700 whitespace-nowrap">{channel.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-4 min-h-[38px] flex items-center justify-center px-3 py-2 rounded-md bg-accent-50 border border-accent-200">
          <p className="text-xs text-accent-800 text-center leading-relaxed">
            {message || "分享功能为演示效果，不会调用任何真实分享接口。"}
          </p>
        </div>
      </div>
    </div>
  );
}